import type { SxProps, Theme } from '@mui/material/styles';
import Snackbar from '@mui/material/Snackbar';
import PropTypes from 'prop-types';
import { centeredPlainSnackbarContentSx, defaultSnackbarContentSx, mergeSx } from './snackbarStyles';

interface BasicSnackBarProps {
  onClose: (open: boolean) => void;
  onExited?: () => void;
  open: boolean;
  message: string;
  vertical: 'top' | 'bottom';
  horizontal: 'center' | 'left' | 'right';
  persistent?: boolean;
  contentSx?: SxProps<Theme>;
}

const BasicSnackBar = (props: BasicSnackBarProps) => {
  const { onClose, onExited, open, message, vertical, horizontal, persistent = false, contentSx } = props;

  const handleClose = (_event: React.SyntheticEvent | Event, reason?: string) => {
    if (persistent && (reason === 'clickaway' || reason === 'escapeKeyDown')) {
      return;
    }
    onClose(false);
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      autoHideDuration={persistent ? null : 3500}
      open={open}
      onClose={handleClose}
      message={message}
      key={`${vertical}-${horizontal}-${persistent ? 'persistent' : 'temporary'}-${message}`}
      slotProps={{
        content: {
          sx: mergeSx(centeredPlainSnackbarContentSx, contentSx ?? defaultSnackbarContentSx),
        },
        transition: {
          onExited,
        },
      }}
    />
  );
};

BasicSnackBar.propTypes = {
  onClose: PropTypes.func.isRequired,
  onExited: PropTypes.func,
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  vertical: PropTypes.string.isRequired,
  horizontal: PropTypes.string.isRequired,
  persistent: PropTypes.bool,
  contentSx: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.array]),
};

export default BasicSnackBar;
